import { TitlePage } from 'components/atoms'
import { InputField } from 'components/molecules'

const SellerBankAccountFields = () => (
  <>
    <TitlePage mainTitle={ 'Seller Bank Account' } />

    <InputField
      type='text'
      name='seller.bank'
      label='Bank Name'
      placeholder='BCA'
      required={ true }
    />
    <InputField
      type='text'
      name='seller.bank_branch'
      label='Bank Branch'
      placeholder='Blok M'
      required={ true }
    />
    <InputField
      type='text'
      name='seller.account_number'
      label='Bank Account No.'
      placeholder='450XXXXXXX'
      required={ true }
    />
    <InputField
      type='text'
      name='seller.account_name'
      label='Bank Account Name'
      placeholder='Cindy Gulla'
      required={ true }
    />
  </>
)

export default SellerBankAccountFields